import React from 'react';
import classes from './FormattedDateTime.module.scss';
import { useTranslation } from 'react-i18next';

export const FormattedDateTime = ({ date }) => {
    const { i18n } = useTranslation();

    const datePart = date.toLocaleDateString();
    const timePart = date.toLocaleTimeString(i18n.language, { hour: '2-digit', minute: '2-digit' });

    return (
        <div>
            <div>{datePart}</div>
            <div className={classes.time}>{timePart}</div>
        </div>
    );
};
